import {colors, shadowLight, spacings} from 'style';
const style = {
    card: {
        width: '220px',
        overflow:'hidden',
        color: colors.themeBlue,
        backgroundColor: '#fff',
        border: 'none',
        paddingLeft: spacings.base,
        paddingRight: spacings.base,
        paddingTop: spacings.base,
        paddingBottom: spacings.base,
        marginLeft: spacings.small,
        marginRight: spacings.small,
        marginTop: spacings.small,
        marginBottom: spacings.small,
        boxShadow: shadowLight,
        borderRadius: '9px',
    },
    iconHeader: {
        position: 'relative',
        padding:'0px 0px 0px 0px', 
        width:'75px',
        height:'75px',
        marginLeft:'auto',
        marginRight:'auto',
        color: colors.themeTeal,
        backgroundColor: '#fff',
    },
    icon: {
        position: 'absolute',
        width: '40px',
        height: '40px',
        fontSize:'40px',
        top: '50%',
        left: '50%',
        marginTop: '-20px',
        marginLeft: '-20px',
    },
    ring:{
        position: 'absolute'
    },
    header: {
        fontSize: '1em',
        color: colors.themeBlue,
    },
    cardContent: {
        border: 'none',
        position: 'relative',
        color: colors.themeBlue,
        paddingBottom: '0',
    },
    value: {
        fontSize: '1.4em',
    }
};

export default style;



// WEBPACK FOOTER //
// ./src/modules/challenges/customCards/style.js